import dayjs from "dayjs";
import { cn } from "@/lib/utils";
import { formatMoneyCompact } from "@/lib/format";

/** Barras verticales por mes: monto adjudicado arriba, número de obras abajo. */
export function MonthlyBars({
  months,
  selected,
}: {
  months: { month: string; awards: number; amount: number }[];
  selected: string;
}) {
  const max = Math.max(...months.map((m) => m.amount), 1);
  const label = months
    .map(
      (m) =>
        `${dayjs(`${m.month}-01`).format("MMMM")}: ${formatMoneyCompact(m.amount)} en ${m.awards} obras`,
    )
    .join("; ");

  return (
    <div role="img" aria-label={label} className="flex flex-col gap-2">
      <div className="grid h-52 grid-cols-6 items-end gap-3 border-b border-slate-200 dark:border-slate-700">
        {months.map((m) => (
          <div key={m.month} className="flex h-full flex-col items-center justify-end gap-1.5">
            <span
              className={cn(
                "text-xs font-bold text-slate-700 dark:text-slate-200",
                m.month === selected && "text-primary",
              )}
            >
              {formatMoneyCompact(m.amount)}
            </span>
            <div
              className={cn(
                "w-full max-w-16 rounded-t-lg",
                m.month === selected ? "bg-primary" : "bg-blue-200 dark:bg-blue-900",
              )}
              style={{ height: `${Math.max(3, (m.amount / max) * 85)}%` }}
            />
          </div>
        ))}
      </div>
      <div aria-hidden className="grid grid-cols-6 gap-3 text-center text-xs">
        {months.map((m) => (
          <div key={m.month} className="flex flex-col">
            <span
              className={cn(
                "font-semibold capitalize text-slate-700 dark:text-slate-200",
                m.month === selected && "font-bold text-primary",
              )}
            >
              {dayjs(`${m.month}-01`).format("MMM")}
            </span>
            <span className="text-slate-500">{m.awards} obras</span>
          </div>
        ))}
      </div>
    </div>
  );
}
